/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import { PrescrFilter, PrescrItem, PrescrTable } from 'models/api/prescr';
import ResTable from 'models/api/table';
import { Key } from 'react';

const url = '/prescoring';

export const getPrescr = async (axios: AxiosInstance, params?: PrescrFilter) => {
    const { data } = await axios.get<ResTable<PrescrTable>>(url, { params });
    return data;
};

export const getPrescrItem = async (axios: AxiosInstance, id: Key) => {
    const { data } = await axios.get<PrescrItem>(`${url}/${id}`);
    return data;
};

export const addPrescrItem = async (axios: AxiosInstance, item: PrescrItem) => {
    const { data } = await axios.post(`${url}`, item);
    return data;
};

export const updatePrescrItem = async (axios: AxiosInstance, id: Key, item: PrescrItem) => {
    const { data } = await axios.put(`${url}/${id}`, item);
    return data;
};

export const deletePrescrItem = async (axios: AxiosInstance, id: Key) => {
    const { data } = await axios.delete(`${url}/${id}`);
    return data;
};

export const getPrescrExcel = async (axios: AxiosInstance, params: PrescrFilter) => {
    const { data } = await axios.get<Blob>(`${url}/excel`, {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};
